/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { PidxNotification } from './models/pidx-notification'
import { PidxNotificationType } from './models/pidx-notification-type.enum'
import { PidxBannerService } from './pidx-banner.service'

type PdsBannerState = 'success' | 'error' | 'warning' | 'info'

@Component({
  selector: 'pidx-notifications',
  templateUrl: './pidx-notifications.component.html',
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PidxNotificationsComponent implements OnInit {
  private notificationsService = inject(PidxBannerService)

  public notifications: PidxNotification[] = []

  ngOnInit() {
    this.notificationsService.notifications.subscribe((notification) => {
      this.notificationsService.queueAddNotification(this.notifications, notification).subscribe(() => {
        this.notifications.push(notification)
      })
    })
  }

  onDismiss(notification: PidxNotification) {
    notification.open = false
  }

  // Maps the semantic notification type to the PDS banner state so success
  // confirmations and errors are not differentiated by colour/icon alone
  // (WCAG 1.4.1 Use of Color).
  bannerState(notification: PidxNotification): PdsBannerState {
    if (notification.type === PidxNotificationType.SUCCESS) {
      return 'success'
    }
    if (notification.type === PidxNotificationType.ERROR) {
      return 'error'
    }
    return 'info'
  }
}
